// extracted by mini-css-extract-plugin
export default {"moreBtn":"MoreBtn_moreBtn__qvS6t","text":"MoreBtn_text__QQmEa","img":"MoreBtn_img__Y0R8B","arrowIcon":"MoreBtn_arrowIcon__l+MdT"};